var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { TextInput } from "./TextInput";
import { Button } from "./Button";
import { Spinner } from "./Spinner";
import { Modal } from "./Modal";
export function ConfirmationDialog(_a) {
    var _this = this;
    var onClose = _a.onClose, onConfirm = _a.onConfirm, validationText = _a.validationText, confirmText = _a.confirmText, dialogTitle = _a.dialogTitle, dialogBody = _a.dialogBody, _b = _a.disableCancel, disableCancel = _b === void 0 ? false : _b, _c = _a.disableConfirm, disableConfirm = _c === void 0 ? false : _c, _d = _a.variant, variant = _d === void 0 ? "danger" : _d, error = _a.error;
    var _e = __read(useState(""), 2), validation = _e[0], setValidation = _e[1];
    var _f = __read(useState(false), 2), isConfirming = _f[0], setIsConfirming = _f[1];
    var handleConfirm = function () { return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsConfirming(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onConfirm()];
                case 2:
                    _a.sent();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setIsConfirming(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var disabled = disableConfirm || isConfirming || validationText
        ? validation.trimStart().trimEnd() !==
            (validationText === null || validationText === void 0 ? void 0 : validationText.trimStart().trimEnd())
        : false;
    return (<Modal title={dialogTitle} onClose={onClose} size="sm">
      <div className="pb-3">
        {dialogBody}{" "}
        {validationText && (<>
            <div className="mt-4 text-sm">
              Type{" "}
              <code className="rounded bg-background-tertiary p-1 text-sm text-content-primary">
                {validationText}
              </code>{" "}
              in the box below to confirm.
            </div>
            <TextInput id="validation" labelHidden onKeyDown={function (e) {
                return e.key === "Enter" && !disabled && handleConfirm();
            }} autoFocus outerClassname="mt-4" placeholder={validationText} onChange={function (event) { return setValidation(event.target.value); }} value={validation} error={error}/>
          </>)}
      </div>
      <div className="flex w-full gap-2">
        <div className="grow">&nbsp;</div>
        <Button variant="neutral" onClick={onClose} disabled={disableCancel}>
          Cancel
        </Button>
        <Button data-testid="confirm-button" disabled={disabled || isConfirming} onClick={handleConfirm} icon={isConfirming ? <Spinner /> : undefined} variant={variant}>
          {confirmText}
        </Button>
      </div>
    </Modal>);
}
